import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DSEnea } from "src/app/_interfaces/dsEnea";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: "root",
})
export class DsEneaService {
    private baseUrl: string = environment.baseUrl;

    constructor(private http: HttpClient) { }

    getDsEnea(idLavoro: number): Observable<{ data: DSEnea[] }> {
        return this.http
            .get(`${this.baseUrl}/ds_enea/by_lavoro/${idLavoro}`)
            .pipe(map((res: { data: DSEnea[] }) => res));
    }

    addDsEnea(DSEnea: DSEnea): Observable<{ res: string, message: string }> {
        return this.http.post(`${this.baseUrl}/ds_enea/add`, DSEnea).pipe(
            map((res: { res: string, message: string }) => res));
    }

    updDsEnea(DSEnea: DSEnea): Observable<{ res: string, message: string }> {
        return this.http.post(`${this.baseUrl}/ds_enea/up`, DSEnea).pipe(
            map((res: { res: string, message: string }) => res));
    }

    delDsEnea(id: number): Observable<any> {
        return this.http
            .post(`${this.baseUrl}/ds_enea/del`, { "dse_id": id })
            .pipe(map((res: any) => res));
    }
}
